<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" plain v-if="permission.JOINS_SALES_CLOUD_SHOP_ADD"
            @click.stop="handleAdd()">新增</el-button>
          <!-- 删除 -->
          <el-button type="danger" icon="el-icon-delete" size="small" plain
            @click.stop="handleDel('DELETE_OPTION', 'DELETE')">删除</el-button>
        </template>
      </avue-crud>
      <el-dialog title="" :visible.sync="dialogFormVisible" width="30%">
        <el-form :model="addForm">
          <el-form-item label="司机手机号" style="display:flex;justify-content: center;">
            <el-input v-model="shopAccount" placeholder="请输入司机手机号" style="width:220px;">
            </el-input>
          </el-form-item>
          <el-form-item label="司机名称" style="display:flex;justify-content: center;">
            <el-input disabled style="margin-left:14px;width:220px" v-model="shopName"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="openAdd">确 定</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { shopTableOption } from "@/const/work/waterProof/shopOption";
import {
  v1BindingRegistryShop,
  delShop,
  v1BindingList,
  v1BindingDetermine,
  v1BindingBindingShop,
  getRootDepartmentId
} from "@/api/work/waterProof/shop";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "shop",
  components: {},
  data() {
    return {
      tableOption: shopTableOption,
      tableData: [],
      tableLoading: false,
      dialogFormVisible: false,
      rootDepartmentId: "",
      addForm: {},
      shopAccount: "",
      codeDialogVisible: false,
      codeImage: '',
      shopName: "",
      isShow: false,
      resData: {},
      tabelObj: {},
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      grade: {
        box: false,
        check: []
      },
      dutyIdCardFrontImg: "",
      dutyIdCardBackImg: "",
      businessLicense: [],
      fileList: [],
      point: {}
    };
  },
  created() {
    this.handleList();
  },
  watch: {
    shopAccount(mobile) {
      if (mobile.length == 11) {
        let params = {};
        params.mobile = mobile;
        v1BindingDetermine(params).then(res => {
          if (res.data) {
            let data = JSON.parse(res.data);
            this.resData = data;
            this.shopName = data.shopName;
            this.isShow = true;
          } else {
            // 提示还未注册
            this.$message({
              showClose: true,
              message: "当前手机号暂未注册店铺",
              type: "warning"
            });
            this.shopName = "";
            this.isShow = false;
          }
        });
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    resetDialog() {
      this.codeImage = '';
      this.shopName = '';
    },
    deletePic(item) {
      let index = this.businessLicense.indexOf(item);
      if (index > -1) {
        this.businessLicense.splice(index, 1);
      }
    },
    deleteBack() {
      this.dutyIdCardBackImg = "";
    },
    deleteFront() {
      this.dutyIdCardFrontImg = "";
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.shopAddress = params.address;
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    clean() {
      this.dutyIdCardFrontImg = "";
      this.dutyIdCardBackImg = "";
      this.businessLicense = [];
      this.point = {};
      this.shopAccount = "";
      this.shopName = "";
      this.resData = {};
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.dialogFormVisible = true;
    },
    openAdd() {
      if(this.isShow){
      let params = {};
      params.shopId = this.resData.id;
        v1BindingBindingShop(params).then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "新增绑定成功",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.this.shopName = "";
          }
        });
      }else{
        this.$message({
          showClose: true,
          message: "当前手机号暂未注册店铺",
          type: "warning"
        });
      }
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      v1BindingList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        console.log('this.tableData::: ', this.tableData);
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pcode;
      row.city = this.point.adcode.substring(0, 4) + "00";
      row.area = this.point.adcode;
      row.dutyIdCardFrontImg = this.dutyIdCardFrontImg;
      row.dutyIdCardBackImg = this.dutyIdCardBackImg;
      row.businessLicense = this.businessLicense;
      v1BindingRegistryShop(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
     handleSelectionChange(val) {
      let ids = val.map((item) => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delShop(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => { });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
